import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGraphCommands } from '../constant';
export var NsGraphHistoryReset;
(function (NsGraphHistoryReset) {
    /** Command: 用于注册named factory */
    NsGraphHistoryReset.command = XFlowGraphCommands.GRAPH_HISTORY_RESET;
    /** hookName */
    NsGraphHistoryReset.hookKey = 'historyReset';
})(NsGraphHistoryReset || (NsGraphHistoryReset = {}));
let GraphHistoryResetCommand = 
/** 创建清理History命令 */
class GraphHistoryResetCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            const result = yield hooks.historyReset.call(args, () => __awaiter(this, void 0, void 0, function* () {
                const graph = yield ctx.getX6Graph();
                graph.cleanHistory();
                return { err: null };
            }), runtimeHook);
            ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            if (this.isUndoable()) {
                ctx.undo();
            }
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable()) {
                yield this.execute();
            }
            return this;
        });
    }
    isUndoable() {
        const ctx = this.contextProvider();
        return ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphHistoryResetCommand.prototype, "contextProvider", void 0);
GraphHistoryResetCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsGraphHistoryReset.command.id },
    })
    /** 创建清理History命令 */
], GraphHistoryResetCommand);
export { GraphHistoryResetCommand };
//# sourceMappingURL=graph-history-reset.js.map